// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //apiURL: 'http://localhost:5001/workleague/europe-west1',
  apiURL: 'https://europe-west1-workleague.cloudfunctions.net',
  firebaseConfig: {
    apiKey: "AIzaSyBb7SL212JTTHFU-y-ZaXUu5R6lt5n0gpc",
    authDomain: "workleague.firebaseapp.com",
    databaseURL: "https://workleague-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "workleague",
    storageBucket: "workleague.appspot.com",
    messagingSenderId: "422693643102",
    appId: "1:422693643102:web:e1ff05e1cb7a5cc29c65cf",
    measurementId: "G-8FMGRH5XJE"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
